import { guides } from "@/mocks/site";
import SectionHeading from "@/pages/home/components/SectionHeading";
import Reveal from "@/components/feature/Reveal";

export default function Guides() {
  return (
    <section id="guides" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="Watch Guide"
          title="追剧指南与选剧方法"
          desc="除了剧集本身，这里整理了几篇实用内容，帮你在档期安排、评分辨析与题材入门上少走弯路。"
        />

        <div className="mt-8 md:mt-10 grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
          {guides.map((guide, index) => (
            <Reveal key={guide.id} delay={index * 90}>
              <article className="h-full rounded-lg overflow-hidden bg-background-50 border border-background-200 flex flex-col transition-colors duration-300 hover:border-primary-300">
                <div className="w-full aspect-[16/10] overflow-hidden bg-background-200">
                  <img
                    src={guide.cover}
                    alt={`${guide.title} 配图`}
                    title="韩剧TV 追剧指南"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-5 md:p-6 flex flex-col flex-1">
                  <div className="flex items-center gap-3">
                    <span className="px-2.5 py-1 rounded-full text-xs font-label bg-accent-100 text-accent-900">
                      {guide.category}
                    </span>
                    <span className="inline-flex items-center gap-1 text-xs font-label text-foreground-500">
                      <i className="ri-time-line" aria-hidden="true" />
                      {guide.readTime}
                    </span>
                  </div>
                  <h3 className="mt-3 text-lg font-heading font-bold text-foreground-950 leading-snug">
                    {guide.title}
                  </h3>
                  <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed">
                    {guide.excerpt}
                  </p>
                  <ul className="mt-4 space-y-2 flex-1">
                    {guide.points.map((point) => (
                      <li key={point} className="flex items-start gap-2 text-sm text-foreground-700">
                        <i className="ri-checkbox-circle-line text-secondary-600 mt-0.5 shrink-0" aria-hidden="true" />
                        <span>{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}